import { useLocation, useNavigate } from "react-router-dom";
import { Home, FileText, Users, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const navItems = [
    { path: "/dashboard", icon: Home, label: "Accueil" },
    { path: "/claims", icon: FileText, label: "Dossiers" },
  ];

  if (user?.role === "company") {
    navItems.push({ path: "/users", icon: Users, label: "Équipe" });
  }

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className="mobile-nav" data-testid="mobile-nav">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + "/");
        const Icon = item.icon;
        
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            className={`mobile-nav-item ${isActive ? "active" : ""}`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon className="w-6 h-6" />
            <span className="text-xs">{item.label}</span>
          </button>
        );
      })}
      <button
        onClick={handleLogout}
        className="mobile-nav-item text-red-500"
        data-testid="nav-logout"
      >
        <LogOut className="w-6 h-6" />
        <span className="text-xs">Sortir</span>
      </button>
    </nav>
  );
};

export default MobileNav;
